export const AI_MODELS = {
  CLAUDE_HAIKU_4_5: 'claude 4.5 haiku',
}

export const AI_ACTIONS = {
  ANALYZE_PDF: 'analyze_pdf',
}
